// The admin console's API client.
//
// The request pipeline lives in `@vista-cloud/web-common` (vista#671). This
// file used to hold its own copy, which still sent
// `Content-Type: application/json` on body-less requests — and the console's
// own `POST /auth/session` and `/auth/session/refresh` send no body, as do two
// of its DELETEs. The org copy had fixed that under vista#380; this one had
// not, which is the drift that motivated hoisting the pipeline.
//
// The console is same-origin by deployment: the admin worker is bound to
// `admin.vista-cloud.io/api/*`, so VITE_API_BASE is empty in both
// `.env.production` and `.env.staging`. The shared client handles either.

import { createApiClient } from '@vista-cloud/web-common';

const API_BASE = import.meta.env.VITE_API_BASE || window.location.origin;

const client = createApiClient({ apiBase: API_BASE });

export const { api, setVistaToken, getVistaToken } = client;
